import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const exportPendingFundsData = async ({ fiduciaryNumber, clientNumber }) => {
  let url = `/pendingfiduciaryfunds/${fiduciaryNumber}/export`;
  if (clientNumber !== 0) {
    url += `?fiduciaryClientId=${clientNumber}`;
  }
  return request.get(url);
};

export const exportFundsData = async ({ fiduciaryNumber, clientNumber, queryOptions }) => {
  let url = '';
  if (clientNumber === 0) {
    url += `/fiduciaries/${fiduciaryNumber}/funds/export`;
  } else {
    url += `/fiduciaryclients/${clientNumber}/funds/export`;
  }
  if (queryOptions !== '') {
    url += `?${queryOptions}`;
  }
  return request.get(url);
};
